<template>
    <div>
        <div class="option-title" v-if="!showPlaneMode">Produtos</div>
        <div class="option-title-edit" v-else>
            <ul>
                <li><strong>Produtos</strong></li>
            </ul>
        </div>
        <div class="frame-option" :class="[!showPlaneMode ? 'disable-styles px-4' : 'edit-styles']">
            <li>
                <p class="option-subtitle">Quais produtos estão disponíveis em Uma Penca?</p>
                <p>
                    Por enquanto, nosso catálogo conta com as seguintes opções:<strong>
                        camisetas, pôsteres (A5, A4 e A3), bottons, ímãs, canecas e ecobags.</strong
                    >
                    Mas estamos sempre em busca de novas possibilidades para materializar suas
                    ideias. Caso tenha alguma sugestão, não deixe de compartilhar com a gente.
                </p>
            </li>

            <li>
                <p class="option-subtitle">Como cada produto é estampado?</p>
                <p>
                    <strong>Bottons e Ímãs:</strong> Ambos possuem 3,5 cm de diâmetro e são feitos
                    por impressão digital de alta resolução em papel com envelopamento plástico,
                    garantindo maior fidelidade à arte criada.
                </p>
                <p>
                    <strong>Canecas:</strong> Nossas canecas são de cerâmica, e a impressão da
                    estampa é feita por <strong>termotransferência</strong>, um processo que garante
                    fidelidade às cores exibidas nas fotos do produto. Fique à vontade para usá-la
                    no forno micro-ondas, mas evite colocar na lava-louças!
                </p>
                <p>
                    <strong>Pôsteres (A5, A4 e A3):</strong> Nossos posters são impressos sob
                    demanda e com alta resolução em papel fotográfico de 260g. A impressão é à base
                    de solvente e não borra com água. Mas, atenção: ao molhar, o papel enruga e pode
                    até rasgar. Por isso, recomendamos que a limpeza seja feita sempre com um pano
                    seco. Eles são enviados em tubetes, garantindo que cheguem nas melhores
                    condições até você!
                </p>
                <p>
                    <strong>Camisetas e Ecobags:</strong> Trabalhamos com técnicas de estamparia
                    digital. Utilizamos impressoras que empregam tecnologia de ponta para impressão
                    especial em tecido e diferentes superfícies, garantindo o maior nível de
                    fidelidade possível, tudo no capricho e no estilo.
                </p>
                <p>
                    Entretanto, lojas que apresentem um volume acima de 100 unidades/mês de uma
                    mesma camiseta, passarão por uma análise de viabilidade técnica para então serem
                    produzidas em Serigrafia, visando uma entrega mais ágil aos nossos clientes.
                </p>
                <p>
                    O lojista será notificado previamente caso um de seus produtos se enquadre nas
                    características acima.
                </p>
            </li>

            <li>
                <p class="option-subtitle">Qual é o tecido das camisetas?</p>
                <p>
                    Nossas camisetas são produzidas artesanalmente com
                    <strong>100% de fibra natural de algodão sustentável*</strong>, refinada e
                    penteada. Além disso, nossa malha é vegana.
                </p>
                <p>
                    A camiseta DryFit é composta por tecido 100% poliéster e contém proteção UV com
                    FPS 30.
                </p>
                <p>
                    <i>*Exceto a opção Cinza Mescla, composta por 88% algodão e 12% poliéster.</i>
                </p>
            </li>

            <li>
                <p class="option-subtitle">Posso fazer estampas frente e costas?</p>
                <p>
                    No momento, nossas camisetas estão disponíveis apenas com estampas na parte da
                    frente.
                </p>
            </li>

            <li>
                <p class="option-subtitle">‍É possível o lojista receber amostras dos produtos?</p>
                <p>
                    Não disponibilizamos amostras. Todos os produtos têm a qualidade Chico Rei, no
                    que diz respeito ao tecido, modelagem, corte e estamparia digital.
                </p>

                <p>
                    Na página de cada produto, você também encontrará informações técnicas
                    referentes aos materiais e processos utilizados.
                </p>
                <p>
                    A sugestão é que o lojista adquira produtos de sua própria loja pelo preço base
                    da plataforma. Basta cadastrar cada um deles, aguardar aprovação e realizar o
                    pedido normalmente. O desconto das taxas será automático na sacola,<i>
                        mas é necessário remover todos cupons e produtos de outras lojas para que o
                        mesmo seja validado.</i
                    >
                    <strong>
                        <a href="/termos-condicoes/precos"
                            >Clique aqui e confira mais detalhes sobre preços e ganhos.</a
                        ></strong
                    >
                </p>
            </li>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ProductTerms',

        props: {
            showPlaneMode: {
                default: false,
                type: Boolean,
            },
        },
    };
</script>
